import { observer } from 'mobx-react'
import React, { Fragment, Component } from 'react'
import i18n from 'i18next'

import Button from '../../../UniformComponents/Button'

@observer
class Downloading extends Component {
    constructor(props) {
        super(props)
        props.store.download(props.includeQuestions)
    }

    capitaliseType = (val) => {
        if (['csv', 'pdf', 'ppt'].includes(val)) return val.toUpperCase()
        return val
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join('-')
    }

    getDownloadLinks = () => {
        const { store } = this.props
        const {
            downloadUrl,
            downloadAttribute,
        } = store
        const { primary, secondary } = downloadUrl
        const fileType = this.capitaliseType(store.getDownloadType())
        const links = [{ url: primary, downloadAttribute, type: fileType }]
        if (fileType === 'Triple-S') {
            links.push({ url: secondary, downloadAttribute, type: 'CSV' })
        }

        return (
            <div style={{ marginBlock: 24 }}>
                {i18n.t('download.modal.download_finished.1')}
                <br />
                <br />
                <span>
                    {i18n.t('download.modal.download_finished.2')}
                    {' '}
                    {links.map((l, idx) => (
                        <a
                            href={l.url}
                            target="_blank"
                            rel="noreferrer"
                            download={l.downloadAttribute}
                        >
                            {l.type}
                            {idx < links.length - 1 ? ', ' : ''}
                        </a>
                    ))}
                </span>
            </div>
        )
    }

    renderH2 = () => {
        const { store } = this.props
        const { loading, downloadError } = store

        let title = i18n.t('download.modal.downloading')
        if (downloadError) {
            title = i18n.t('download.modal.download_error')
        } else if (!loading) {
            title = i18n.t('download.modal.download_ready')
        }

        return (
            <h2>
                {title}
            </h2>
        )
    }

    renderP = () => {
        const { store } = this.props
        const { loading, downloadError } = store

        let title = ''
        if (downloadError) {
            title = downloadError
        } else if (!loading) {
            title = this.getDownloadLinks()
        }

        return (
            <p className="uc-modal__desc">{title}</p>
        )
    }

    renderIcon = () => {
        const { store } = this.props
        const { loading, downloadError } = store
        const background = downloadError ? '#FE3A29' : '#16CCC1'

        let icon = 'fas fa-check'
        if (downloadError) {
            icon = 'fa-regular fa-ban'
        } else if (loading) {
            icon = 'fa-regular fa-spinner'
        }

        return (
            <div
                style={{
                    width: '61px',
                    height: '61px',
                    borderRadius: '100px',
                    color: '#FFF',
                    background,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '32px',
                }}
            >
                <i className={icon} />
            </div>
        )
    }

    render() {
        const { onClose } = this.props
        return (
            <Fragment>
                <div className="uc-modal__header">
                    {this.renderH2()}
                    {this.renderP()}
                </div>
                <div className="body" style={{ justifyContent: 'center' }}>
                    {this.renderIcon()}
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        label={i18n.t('close')}
                        cssClass="tertiary"
                        onClick={onClose}
                    />
                </div>
            </Fragment>
        )
    }
}

export default Downloading
